import { AccountType } from 'dashboard/models/account-type';
import { CaseAssignmentPolicy } from 'dashboard/models/case-assignment-policy';
import { CaseQueue } from 'dashboard/models/case-queue';
import { CaseTemplate } from 'dashboard/models/case-template';
import { ExternalIntegration } from 'dashboard/models/external-integration';
import { InquiryTemplate } from 'dashboard/models/inquiry-template';
import { List } from 'dashboard/models/list';
import { ReportTemplate } from 'dashboard/models/report-template';
import { CasesTableView } from 'dashboard/models/table-view';
import { Team } from 'dashboard/models/team';
import { Template } from 'dashboard/models/template';
import { TransactionType } from 'dashboard/models/transaction-type';
import { VerificationTemplate } from 'dashboard/models/verification-template';
import { Workflow } from 'dashboard/models/workflow';
import { Permission } from 'lib/permissions';

export type PermissionObjectType =
  | AccountType
  | CaseAssignmentPolicy
  | CaseTemplate
  | CaseQueue
  | ExternalIntegration
  | InquiryTemplate
  | List
  | ReportTemplate
  | CasesTableView
  | Team
  | Template
  | TransactionType
  | VerificationTemplate
  | Workflow;

export const ADMIN_ROLE_NAME = 'Admin';

// No scope provided effectively means global (Organization).
export enum PermissionScope {
  AccountType = 'Account Type',
  Environment = 'Environment',
  CaseAssignmentPolicy = 'Case Assignment Policy',
  CaseTemplate = 'Case Template',
  CaseQueue = 'Case Queue',
  InquiryTemplate = 'Inquiry Template',
  LegacyExternalIntegration = 'LegacyExternalIntegration',
  List = 'List',
  ReportTemplate = 'Report Template',
  TableView = 'Table View',
  Team = 'Team',
  TransactionType = 'Transaction Type',
  VerificationTemplate = 'Verification Template',
  Workflow = 'Workflow',
}

export enum PermissionAction {
  Create = 'Create',
  List = 'List',
  View = 'View',
  Edit = 'Edit',
}

export type PermissionTableDataType = {
  sections: PermissionSectionDataType[];
};

export type PermissionSectionDataType = {
  label: string;
  subSections: PermissionSubSectionDataType[];
  objectIds?: string[];
  tooltip?: string;
};

export type PermissionSubSectionDataType = {
  scopes: PermissionScope[];
  rows: PermissionRowDataType[];
  objectIds?: string[];
};

export type PermissionRowDataType = {
  label: string;
  actions: PermissionActionDataType[];
  tooltip?: string;
};

// James: A single checklist can toggle multiple permissions. This makes for the
// easiest migration path for now.
type PermissionActionDataType = {
  label: PermissionAction;
  permissions: ScopedPermission[];
};

export type ScopedPermission = {
  permission: Permission;
  scopes: PermissionScope[];
};
